import React from "react";
import TeamsList from "../../Team/TeamsList";

const Teams = () => {
  return (
    <>
      <div className={"mb-2"}>
        <TeamsList />
      </div>
    </>
  );
};

export default Teams;
